/**
 * Shared constants across Vue components
 */

export const PARENTAL_GUIDANCE_TEXT =
  "In Begleitung der Eltern oder einer erziehungsbeauftragten Person für Kinder ab 6 Jahren erlaubt";

export const FILTER_SPLIT_CHAR = "|";
export const FILTER_NULL_VALUE = "alle";

/**
 * Order of filter params in the URL hash
 * URL format: #filter/series/date/release/cinema/auditorium/fsk
 */
export const FILTER_PARAM_ORDER = ["series", "date", "release", "cinema", "auditorium", "fsk"];
